"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require("react-bootstrap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NotificationItem = (_temp2 = _class = function (_Component) {
  _inherits(NotificationItem, _Component);

  function NotificationItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NotificationItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotificationItem.__proto__ || Object.getPrototypeOf(NotificationItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleDismiss = function () {
      if (_this.props.onDismiss) {
        _this.props.onDismiss();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NotificationItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var time = this.props.time;

      if (time) {
        this.timeoutID = setTimeout(this.handleDismiss, time);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timeoutID) {
        window.clearTimeout(this.timeoutID);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          bsStyle = _props.bsStyle,
          message = _props.message,
          onDismiss = _props.onDismiss,
          title = _props.title;

      var showDismissBtn = Boolean(onDismiss);
      return _react2.default.createElement(
        _reactBootstrap.Alert,
        {
          bsStyle: bsStyle,
          className: "erg-components-NotificationItem",
          onDismiss: showDismissBtn ? this.handleDismiss : undefined },
        _react2.default.createElement(
          "p",
          null,
          title
        ),
        _react2.default.createElement(
          "p",
          null,
          message
        )
      );
    }
  }]);

  return NotificationItem;
}(_react.Component), _class.displayName = "NotificationItem", _class.propTypes = {
  bsStyle: _propTypes2.default.oneOf(["danger", "info", "success", "warning"]),
  message: _propTypes2.default.node.isRequired,
  onDismiss: _propTypes2.default.func,
  time: _propTypes2.default.number,
  title: _propTypes2.default.node.isRequired
}, _class.defaultProps = {
  bsStyle: "info",
  message: "",
  title: ""
}, _temp2);
exports.default = NotificationItem;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/NotificationItem.js
 ** module id = 390
 ** module chunks = 0
 **/